/**
 * IRIS_E2E_TEST-only seam that treats the RTSP video step as ready, so hardware-free
 * e2e specs can add a camera whose stream never plays. Inert unless the Electron
 * process runs with `IRIS_E2E_TEST=1` and the spec sets `__irisForceRtspVideoReady`.
 *
 * @returns True only when both the e2e flag and the seam are set.
 */
export const isRtspReadyOverrideEnabled = (): boolean => {
  try {
    const runtime = globalThis as {
      __irisForceRtspVideoReady?: boolean;
      window?: { electron?: { process?: { env?: Record<string, string> } } };
    };
    const e2eEnabled = runtime.window?.electron?.process?.env?.IRIS_E2E_TEST === '1';
    return e2eEnabled && runtime.__irisForceRtspVideoReady === true;
  } catch {
    return false;
  }
};
